import TextInput from '../../lib/TextField';
import en from '../../lang/en-us';
import { Button, Dialog } from '@material-ui/core';
import { connect } from 'react-redux';
import { RootStateType } from '../../redux-store/reducers';
import { AuthState } from '../../redux-store/types/login';
import { SubmitButton, SubmitButtonWithLoader } from '../../lib/Button';
import { updateFirstTimeSettings } from '../../redux-store/actions/login';
import { useState, useEffect } from 'react';
import { resetPin } from '../../redux-store/actions/mobile';
import { EncodeBase64 } from '../../utils/utilityFunctions';

const { loginAuth, dashboard } = en;

interface PinSetProps extends AuthState {
    updateFirstTimeSettings: (body: Partial<AuthState>) => void;
    resetPin: (body: any) => Promise<any>;
    history: any;
}

function ResetPin(props: PinSetProps) {
    const [pin, setPin] = useState<{ value: string; message: string }>({ value: '', message: '' });
    const [newPin, setNewPin] = useState<{ value: string; message: string }>({
        value: '',
        message: '',
    });

    const [successModal, setSuccessModal] = useState<boolean>(false);
    const [loading, setLoading] = useState<boolean>(false);

    const onSetPin = async () => {
        if (pin.value === newPin.value) {
            setNewPin((pin) => ({ ...pin, message: 'New pin should be different to old pin' }));
            return;
        }
        setLoading(true);
        const _window: any = window;
        const { platform, version, uuid, model } = _window.device;
        try {
            let res = await props.resetPin({
                email: props.email,
                mobile: props.mobile,
                metaData: {
                    appType: 'MOBILE',
                    OSVersion: version,
                    deviceName: model,
                    deviceOS: platform,
                },
                deviceId: EncodeBase64(uuid),
                oldPin: EncodeBase64(pin.value),
                newPin: EncodeBase64(newPin.value),
                pan: props.pan,
                pekrn: props.pekrn,
            });
            if (res.status === 200) {
                setSuccessModal(true);
            }
        } catch (err: any) {
            alert(err.message);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="mobile_mode login-auth set-pin">
            <div style={{ flexDirection: 'row', justifyContent: 'flex-start' }} className="logo">
                <a>
                    <img
                        onClick={() => props.history.goBack()}
                        src="/images/left-arrow-white.svg"
                        alt="back icon"
                    />
                </a>
                <h3>{'Reset PIN'}</h3>
            </div>
            <div className="login-auth-content">
                <img src="/images/set-pin-icon.png" alt="icon" />
                <h3>{loginAuth.resetPin}</h3>
                <TextInput
                    onChange={({ target: { value } }) => {
                        setPin((prev) => ({
                            ...prev,
                            value: value.length > 4 ? prev.value : value,
                            message: '',
                        }));
                        setNewPin((prev) => ({ ...prev, message: '' }));
                    }}
                    label={loginAuth.oldPin}
                    error={!!pin.message}
                    helperText={pin.message}
                    value={pin.value}
                    inputProps={{ inputMode: 'numeric' }}
                />
                <TextInput
                    onChange={({ target: { value } }) => {
                        setNewPin((prev) => ({
                            ...prev,
                            value: value.length > 4 ? prev.value : value,
                            message: '',
                        }));
                        setPin((prev) => ({ ...prev, message: '' }));
                    }}
                    label={loginAuth.newPin}
                    error={!!newPin.message}
                    helperText={newPin.message}
                    value={newPin.value}
                    inputProps={{ inputMode: 'numeric' }}
                />
                <SubmitButtonWithLoader
                    fullWidth
                    disabled={
                        !pin.value ||
                        !newPin.value ||
                        pin.value.length < 4 ||
                        newPin.value.length < 4
                    }
                    onClick={onSetPin}
                    label="RESET"
                    type="submit"
                    loading={loading}
                    labelWhileLoading="Sending..."
                />
            </div>

            <Dialog maxWidth={'sm'} open={successModal} aria-labelledby="feedback-success-modal">
                <div className="feedback-success-modal">
                    <img src="/images/green-tick.svg" alt="icon" />
                    <h4>{loginAuth.resetPinSuccess}</h4>
                    <SubmitButton
                        onClick={() => {
                            setSuccessModal(false);
                            props.history.goBack();
                        }}
                        type="submit"
                        label={dashboard.noteModals.okayTxt}
                    />
                </div>
            </Dialog>
        </div>
    );
}

export default connect(({ authReducer }: RootStateType) => ({ ...authReducer }), {
    updateFirstTimeSettings,
    resetPin,
})(ResetPin);
